import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	entityUID: '',
	category: 'StaffPicks',
	categories: [],
	selectedGraph: '',
	previewGraph: null,
	isEdition: false,
	canEdit: true,
	cancelUrl: '',
}

function initialize(state, action) {
	return {
		...state,
		entityUID: action.desmosUID,
	}
}

function initializeSuccess(state, action) {
	return {
		...state,
		previewGraph: action.data.currentGraph ? action.data.currentGraph : null,
		isEdition: action.data.currentGraph ? true : false,
		canEdit: action.data.canEdit,
		cancelUrl: action.data.cancelUrl,
	}
}

function getResultsSuccess(state, action) {
	const category = action.data.categories.find( category => !!category.graphs.find(graph => graph.graphId === state.previewGraph))
	return {
		...state,
		categories: action.data.categories,
		category: category ? category.categoryName : state.category,
	}
}

function setSelectedGraph(state, action) {
	return {
		...state,
		selectedGraph: action.graphId,
	}
}

function setPreviewGraph(state, previewGraph) {
	return {
		...state,
		previewGraph,
	}
}

function editDesmos(state) {
	return {
		...state,
		previewGraph: null,
		isEdition: false,
	}
}

function changeCategory(state, action) {
	return {
		...state,
		category: action.categorySelected,
	}
}

const desmosReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.DESMOS_INITIALIZE_SUCCESS: {
			return initializeSuccess(state, action)
		}
		case actionTypes.DESMOS_INITIALIZE_CREATION_TOOL:
		case actionTypes.DESMOS_INITIALIZE_CREATION_TOOL_STANDALONE: {
			return initialize(state, action)
		}
		case actionTypes.DESMOS_GET_RESULTS_SUCCESS: {
			return getResultsSuccess(state, action)
		}
		case actionTypes.DESMOS_GRAPH_SELECTED: {
			return setSelectedGraph(state, action)
		}
		case actionTypes.DESMOS_GRAPH_PREVIEW_SELECTED: {
			return setPreviewGraph(state, action.graphId)
		}
		case actionTypes.DESMOS_CANCEL_GRAPH_PREVIEW: {
			return setPreviewGraph(state, null)
		}
		case actionTypes.DESMOS_EDIT_DESMOS: {
			return editDesmos(state, action)
		}
		case actionTypes.DESMOS_CATEGORY_DESMOS_SELECTED: {
			return changeCategory(state, action)
		}
		default: return state
	}
}
export default desmosReducer
